export const testIds = {
  effectiveDatesStart: "effective-dates-start",
  effectiveDatesEnd: "effective-dates-end",
};
